<script lang="ts">
  import DeleteIcon from '$icons/DeleteIcon.svelte';
  import EditPencilIcon from '$icons/edit/EditPencilIcon.svelte';
  import LinkIcon from '$icons/links/LinkIcon.svelte';
  import LogoutIcon from '$icons/LogoutIcon.svelte';
  import Button from '$lib/components/reusable/Button.svelte';
  import { VITE_APP_BASE_URL } from '$lib/env';
  import {
    HackathonPhase,
    type HackathonWithPhase,
    type ProjectMember,
    type HackathonProject,
  } from '$shared/lib';
  import { copyToClipBoard } from '$utils';
  import { toastCustom } from '$utils/toasts';
  import type { User } from 'src/routes/(app)/+layout.server';

  export let project: HackathonProject<ProjectMember>;
  export let hackathon: HackathonWithPhase | null = null;
  export let user: User | null = null;
  export let showDeleteProjectModal = false;
  export let showLeaveTeamModal = false;

  $: isTeamMember = user && project.teamMembers.some((member) => member.username === user.username);
  $: isProjectFromCurrentHackathon = hackathon && project.hackathonId === hackathon.id;
  $: isProjectEditor = user
    ? project.teamMembers.some((member) => member.id === user.userId && member.isEditor)
    : false;
  $: isProjectOwner = user && project.ownerId === user.userId;
  $: isHackathonInProgress =
    hackathon &&
    hackathon.phase > HackathonPhase.REGISTRATION &&
    hackathon.phase < HackathonPhase.HACKATHON_ENDED;
</script>

{#if isTeamMember && isProjectFromCurrentHackathon && isHackathonInProgress}
  <div class="mt-3 flex flex-wrap justify-between gap-2">
    <div class="flex flex-wrap gap-2">
      <Button secondary href="/projects/editor" disabled={!isProjectEditor}>
        Edit
        <EditPencilIcon slot="right-icon" />
      </Button>
      {#if isProjectOwner}
        {#if !project.submittedAt}
          <Button danger on:click={() => (showDeleteProjectModal = true)}
            >Delete
            <DeleteIcon slot="right-icon" class="h-4 w-4" />
          </Button>
        {/if}
      {:else}
        <Button size="sm" danger on:click={() => (showLeaveTeamModal = true)}>
          Leave Team
          <LogoutIcon slot="right-icon" class="h-4 w-4" />
        </Button>
      {/if}
    </div>
    <Button
      tertiary
      on:click={() => {
        copyToClipBoard(`${VITE_APP_BASE_URL}/projects/explore/${project.slug}`);
        toastCustom({
          position: 'bottom-center',
          informational: true,
          title: 'Project URL copied to clipboard.',
        });
      }}
    >
      Share
      <LinkIcon class="text-gray-dark-12 h-5 w-5 cursor-pointer" />
    </Button>
  </div>
{/if}
